import actionTypes from '../actions/login/actionType';

const initialState = {
  loginLoading: false,
  logoutLoading: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_LOADING: {
      const loading = state[payload];
      return {
        ...state,
        [payload]: !loading,
      };
    }
    case actionTypes.USER_LOGIN: {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
};
